export default __webpack_public_path__ + "static/media/rocket_anim_152.68c0c91b.png";